import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e3a62c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_group_option = _resolveComponent("ui-group-option")!
  const _component_ui_group = _resolveComponent("ui-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ui_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_ui_group_option, { class: "ctrl-btns" }, {
          default: _withCtx(() => [
            _createVNode(_component_ui_button, {
              type: "submit",
              onClick: _cache[0] || (_cache[0] = () => $setup.vm.select())
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_icon, { type: "add" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('dataset.joinSBtn')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_ui_button, {
              type: "submit",
              onClick: _cache[1] || (_cache[1] = () => $setup.vm.upload())
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_icon, { type: "uploading" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('dataset.uploadSBtn')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_ui_group, {
      title: _ctx.$t('dataset.all')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ui_group_option, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item) => {
              return (_openBlock(), _createBlock($setup["TreeAtom"], {
                class: _normalizeClass(["tree-atom", { 'init-dataset': item === $setup.main }]),
                title: item.title,
                icon: $setup.icons['dataset'],
                desc: item !== $setup.main ? item.sceneName : _ctx.$t('dataset.initial'),
                active: $setup.active === item,
                onClick: 
            () => {
              $setup.active = item
              $setup.flyDataset(item)
            }
          
              }, _createSlots({
                foot: _withCtx(() => [
                  (!$setup.inDisabled(item) && !item.isCalibrated && !item.isItself)
                    ? (_openBlock(), _createBlock($setup["Info"], {
                        key: 0,
                        class: "err-msg",
                        type: "warning",
                        msg: _ctx.$t('dataset.calibration.gotoTip'),
                        onClick: ($event: any) => (
                $setup.router.push({
                  name: $setup.writeRouteName.spaceDivision,
                  params: { selectId: item.id }
                })
              )
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_ui_icon, { type: "pull-more" })
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["msg", "onClick"]))
                    : _createCommentVNode("v-if", true),
                  (item === $setup.active)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('dataset.pointNum')) + "：" + _toDisplayString(item.pointCount), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('dataset.format')) + "：" + _toDisplayString($setup.getDatasetFormats(item).join(' ')), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, [
                (item.version !== -1)
                  ? {
                      name: "ctrl",
                      fn: _withCtx(() => [
                        (item !== $setup.main)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (item.type !== 'zsgd')
                                ? (_openBlock(), _createBlock(_component_ui_icon, {
                                    key: 0,
                                    type: "del",
                                    ctrl: "",
                                    onClick: ($event: any) => ($setup.delAttach(item)),
                                    disabled: $setup.inDisabled(item)
                                  }, null, 8 /* PROPS */, ["onClick", "disabled"]))
                                : _createCommentVNode("v-if", true),
                              _createCommentVNode(" <ui-icon\n                type=\"transmit\"\n                ctrl\n                @click=\"flyDataset(item)\"\n                :disabled=\"inDisabled(item)\"\n              >\n              </ui-icon> ")
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_ui_icon, {
                                type: "reset",
                                onClick: $setup.refreshHandler,
                                tip: _ctx.$t('sys.reset'),
                                "tip-h": "right",
                                class: _normalizeClass({ disabled: $setup.list.some($setup.inDisabled) }),
                                ctrl: ""
                              }, null, 8 /* PROPS */, ["tip", "class"]),
                              _createCommentVNode(" <ui-icon type=\"transmit\" ctrl @click=\"flyDataset(item)\" :disabled=\"inDisabled(item)\">\n              </ui-icon> ")
                            ], 64 /* STABLE_FRAGMENT */))
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "icon", "desc", "class", "active", "onClick"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"]),
    _createVNode($setup["Control"], {
      onSelect: $setup.selectHandler,
      onUpload: $setup.uploadHandler,
      ref: "vm"
    }, null, 512 /* NEED_PATCH */),
    ($setup.propress)
      ? (_openBlock(), _createBlock($setup["FlotPropress"], {
          key: 0,
          propress: $setup.propress,
          onHide: $setup.cancelHandler
        }, null, 8 /* PROPS */, ["propress"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}